package one.primehealth.analytics.events

object Events {
    data object AppInitialLaunch : AppEvent {
        override val name: String = "app_initial_launch"
    }

    data class OnboardingScreenViewed(
        val screenName: String,
    ) : AppEvent {
        override val name: String = "onboarding_screen_viewed"
        override val properties: Map<String, Any>? = mapOf(
            "screen" to screenName
        )
    }

    data class LoginScreenViewed(
        val origin: Origin,
    ) : AppEvent {
        override val name: String = "login_screen_viewed"
        override val properties: Map<String, Any>? = mapOf(
//            "origin" to when (origin) {
//                Origin.Onboarding -> "onboard"
//                Origin.Paywall -> "paywall"
//            }
        )

        enum class Origin {
            Onboarding,
            Paywall
        }
    }

    data class UserSignInAttempt(
        val email: String,
    ) : AppEvent {
        override val name: String = "user_sign_in_attempt"
        override val userProperties: Map<String, Any>? = mapOf(
            "email" to email
        )
    }

    data class UserSignedUp(
        val email: String?,
        val uid: String,
    ) : AppEvent {
        override val name: String = "user_signed_up"
        override val userProperties: Map<String, Any?>? = mapOf(
            "email" to email,
            "user_id" to uid
        )
        override val critical: Boolean = true
    }

    data class UserAutoSignedUp(
        val email: String?,
        val uid: String,
    ) : AppEvent {
        override val name: String = "user_auto_sign_up"
        override val userProperties: Map<String, Any?>? = mapOf(
            "email" to email,
            "user_id" to uid
        )
        override val critical: Boolean = true
    }

    data class PaywallImpression(
        val paywallVariant: String,
        val onboardingVariant: String,
    ) : AppEvent {
        override val name: String = "paywall_impression"
        override val properties: Map<String, Any>? = mapOf(
            "paywall" to paywallVariant,
            "onboarding" to onboardingVariant
        )
        override val critical: Boolean = true
    }

    data class InitiateCheckout(
        val productId: String,
        val price: String?,
        val isRemarket: Boolean,
    ) : AppEvent {
        override val name: String = "initiate_checkout"
        override val properties: Map<String, Any?>? = mapOf(
            "product" to productId,
            "price_usd" to price,
            "is_remarket" to isRemarket
        )
    }

    data class PurchaseCompleted(
        val productId: String,
        val price: String?,
        val isRemarket: Boolean,
    ) : AppEvent {
        override val name: String = "purchase_completed"
        override val properties: Map<String, Any?>? = mapOf(
            "product" to productId,
            "price_usd" to price,
            "is_remarket" to isRemarket
        )
        override val userProperties: Map<String, Any>? = mapOf(
            "product" to productId,
        )
        override val critical: Boolean = true
    }

    data object UserSubscriptionManagementClicked : AppEvent {
        override val name: String = "user_subscription_management_clicked"
        override val critical: Boolean = true
    }

    data object DeleteAndStartOverClicked : AppEvent {
        override val name: String = "delete_and_start_over_clicked"
        override val critical: Boolean = true
    }
}